import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PatchSubscriptionPaymentMethodBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export function useUpdateSubscriptionPaymentMethod(petId: string) {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PatchSubscriptionPaymentMethodBody) =>
      dataOrThrow(
        await api.patch('/pets/:id/subscription/payment-method', { params: { id: petId }, body })
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['pet-subscription'] }),
  })
}
